module.exports = __webpack_public_path__ + "static/img/SI@2x.415eb2d0.jpg";